import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import {
    EmvioLoadingSpinner as LoadingSpinner
} from '@nexio/emvio-util-ui';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { getMerchantDetails, getIsMerchantDetailsLoading, getMerchantDetailsErrorMessage } from './merchantDetailsEntity';
import { getMerchantDetails as queryForMerchantDetails } from './merchantDetailsActions';
import { toggleModal } from '../Modal/modalActions';
import { toastIfError } from '../../utils/toast';
import ErrorCard from '../ErrorCard/ErrorCard';
import mixpanel from '../../utils/mixpanel';
import MerchantDetailsHeader from './MerchantDetailsHeader/MerchantDetailsHeader';
import PrevetDecision from './PrevetDecision/PrevetDecision';
import SubmittedPrevetInfo from './SubmittedPrevetInfo/SubmittedPrevetInfo';
import { STATUS_MAP } from './MerchantDetailsHeader/MerchantDetailsHeader';
import './MerchantDetailsPage.scss';
import ApplicationView from './ApplicationView/ApplicationView';
import PendingList from './PendingList/PendingList';

// export const mockApplicationData = {
//     "onboardingId": 42715,
//     "detail": {
//       "prevetId": 51,
//       "application": 12263,
//       "cmcMerchantId": 100502,
//       "MID": "515794000007266",
//       "Legal_Name": "Levitation 49",
//       "status": "Live",
//       "contactEmail": "levitation49@gmail.com",
//       "contactName": "Lee Hart",
//       "applicationLink": "https://www.google.com",
//       "applicationToken": "1234567890",
//       "repCode": "150L",
//       "createdAt": "2025-11-19T21:20:26.000Z",
//       "lastUpdatedAt": "2025-11-19T21:20:26.000Z"
//     }
// }
export class MerchantDetailsPage extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        merchantDetails: PropTypes.object,
        isMerchantDetailsLoading: PropTypes.bool,
        error: PropTypes.string,
        onGetMerchantDetails: PropTypes.func.isRequired,
        onToggleModal: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            status: '',
            merchantName: '',
            contactEmail: '',
            contactName: '',
            id: '',
            applicationLink: '',
            applicationToken: ''
        };
    }

    shouldShowApplicationView = () => {
        const { merchantDetails } = this.props;
        const status = _.get(merchantDetails, 'detail.status', '');
        const applicationAttachments = _.get(
            merchantDetails,
            'merchantData.attachments.applicationAttachments',
            []
        );

        const isShowMidStatus = STATUS_MAP.showMid.includes(status);
        const hasAttachments = Array.isArray(applicationAttachments)
            ? applicationAttachments.length > 0
            : !_.isEmpty(applicationAttachments);

        return !isShowMidStatus || hasAttachments;
    };

    scrollToTop = () => {
        const doScroll = () => {
            const scrollContainer = document.querySelector('.layout-body');

            if (scrollContainer) {
                requestAnimationFrame(() => {
                    scrollContainer.scrollTop = 0;
                });
            }

            requestAnimationFrame(() => {
                window.scrollTo(0, 0);
                if (document.documentElement) {
                    document.documentElement.scrollTop = 0;
                }
                if (document.body) {
                    document.body.scrollTop = 0;
                }
            });
        };

        setTimeout(doScroll, 1000);
    };

    componentDidMount() {
        const onboardingId = _.get(this.props.match, 'params.onboardingId');

        this.props.onGetMerchantDetails(onboardingId);
        mixpanel.track('Merchant Details page mounted');
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'error');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'match.params.onboardingId')) {
            const onboardingId = _.get(this.props.match, 'params.onboardingId');
            this.props.onGetMerchantDetails(onboardingId);
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'merchantDetails.detail')) {
            this.setState({
                status: this.props.merchantDetails.detail.status,
                merchantName: this.props.merchantDetails.detail.legalName,
                contactEmail: this.props.merchantDetails.detail.contactEmail,
                contactName: this.props.merchantDetails.detail.contactName,
                id: this.props.merchantDetails.detail.MID,
                applicationId: this.props.merchantDetails.detail.application,
                prevetId: this.props.merchantDetails.detail.prevetId,
                cmcMerchantId: this.props.merchantDetails.detail.cmcMerchantId,
                applicationLink: this.props.merchantDetails.detail.applicationLink,
                applicationToken: this.props.merchantDetails.detail.applicationToken
            });
        }
    }

    render() {
        const { isMerchantDetailsLoading, error, merchantDetails } = this.props;

        if (isMerchantDetailsLoading && _.isEmpty(merchantDetails)) {
            return (
                <div className="emvio-merchant-details-loading">
                    <LoadingSpinner />
                </div>
            );
        }

        if (error) {
            return <ErrorCard errorMessage={error} />;
        }

        if (_.isEmpty(merchantDetails)) {
            return <ErrorCard errorMessage="Merchant details not found" />;
        }

        return (
            <div className="emvio-merchant-details">
                <MerchantDetailsHeader merchantDetails={merchantDetails.detail} />
                <div className="merchant-details-content">
                    {!_.isEmpty(merchantDetails.pendingData) && (
                        <PendingList merchantDetails={merchantDetails} />
                    )}
                    {this.shouldShowApplicationView() && (
                        <ApplicationView merchantDetails={merchantDetails} />
                    )}
                    {!_.isEmpty(merchantDetails.prevetData) && (
                        <div className="prevet-columns">
                            <div className="prevet-column prevet-column-left">
                                <PrevetDecision merchantDetails={merchantDetails} loading={isMerchantDetailsLoading} />
                            </div>
                            <div className="prevet-column prevet-column-right">
                                <SubmittedPrevetInfo merchantDetails={merchantDetails} onToggleModal={this.props.onToggleModal} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        merchantDetails: getMerchantDetails(state),
        isMerchantDetailsLoading: getIsMerchantDetailsLoading(state),
        error: getMerchantDetailsErrorMessage(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetMerchantDetails: (onboardingId) => dispatch(queryForMerchantDetails(onboardingId)),
        onToggleModal: (modalName, data) => dispatch(toggleModal(modalName, data))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MerchantDetailsPage));
